<template>
  <Layout>
    <div class="row justify-content-center">
      <b-card no-body class="overflow-hidden" style="max-width: 540px;">
        <b-row no-gutters>
          <b-col md="4" class="text-center">
            <b-card-img :src="require('@/assets/images/icon_shield.png')" alt="Image" class="rounded-0 logo-shield mt-4"></b-card-img>
          </b-col>
          <b-col md="8">
            <b-card-body title="Verify OTP Code">
              <b-card-text>
                <p class="mb-2">
                  Please enter the 6 digit code
                </p>
                <div class="align-input">
                  <CodeInput :loading="false" class="input mb-3 mt-3" :fieldWidth="48" @change="onInputCode" :values="otpCode"/>
                </div>
                <div class="text-center">
                  <b-button class="btn btn-on btn-default fs-18 fw-light w-100" @click="onClickVerify()">Verify</b-button>
                </div>
                <div class="mt-6 text-center fs-13 mt-2">
                  หากยังไม่ได้ลงทะเบียน
                  <a class="text_blue_link poniter" @click="onClickRequestSendEmail">
                    คลิกที่นี่
                  </a>
                </div>
              </b-card-text>
            </b-card-body>
          </b-col>
        </b-row>
      </b-card>
    </div>
    <modal-warning :title="modalWarning.title" :show="modalWarning.display"  :warningMessages="warningMessages"
      @hidden="modalWarning.display = false"></modal-warning>
  </Layout>
</template>
<script>
import modalWarning from '@/components/shared/modal-warning.vue'
import CodeInput from "vue-verification-code-input";
import Layout from "../../layouts/two-factor";
import axios from 'axios'
import { isValid } from "@/helpers/utils/utils.js";
import { eventBus } from '@/main.js'
export default {
  components: {
    Layout,
    CodeInput,
    'modal-warning': modalWarning,
  },
  data () {
    return {
      modalWarning: {
        display: false,
        title: ''
      },
      warningMessages: [],
      userId: '',
      otpCode: '',
      audienceId: ''
    }
  },
  mounted() {
    console.log('this.$route.query.callbackUrl', this.$route.query.callbackUrl)
    if (this.$route.query !== undefined && this.$route.query !== null) {
      if (isValid(this.$route.query.userId)) {
        this.userId = this.$route.query.userId
      } else {
        this.toggleWarningModal('userID not found')
      }
      if (isValid(this.$route.query.aud)) {
        this.audienceId = this.$route.query.aud
      } else {
        this.toggleWarningModal('audienceId not found')
      }
    } else {
      this.toggleWarningModal('userID not found')
    }
  },
  methods: {
    onInputCode(value) {
      this.otpCode = value
    },
    onClickVerify() {
      if (isValid(this.otpCode) && this.otpCode.length === 6) {
        if (!isValid(this.$route.query.aud)) {
          this.toggleWarningModal('audienceId not found')
        } else if (!isValid(this.$route.query.callbackUrl)) {
          this.toggleWarningModal('callbackUrl not found')
        } else if (!isValid(this.$route.query.userId)) {
          this.toggleWarningModal('userID not found')
        } else {
          this.verifyOTPCode()
        }
      }
    },
    verifyOTPCode() {
      let payload = JSON.stringify({
        'userId': this.userId,
        'pinCode': this.otpCode,
        'audienceId': this.audienceId,
        'referenceId': this.$route.query.jti !== undefined ? this.$route.query.jti : ''
      })
      eventBus.$emit('changeLoadingState', true)
      const params = new URLSearchParams()
      params.append('apikey', process.env.VUE_APP_BASE_TWO_FACTOR_KEY)
      axios({
          method: 'POST',
          baseURL: process.env.VUE_APP_BASE_TWO_FACTOR_API,
          headers: {
            'Content-Type': 'application/json'
          },
          url: `authentications/2fa/token`,
          params: params,
          data: payload
        }).then((result) => {
          console.log('result', result)
          if (result.data.key === true) {
            let decodeCallbackUrl = atob(this.$route.query.callbackUrl)
            window.location.href = `${decodeCallbackUrl}?twoFactorToken=${result.data.token}`
          } else this.toggleWarningModal('OTP Code ไม่ถูกต้อง')
        }).catch(error => {
          console.log(error.response)
          this.toggleWarningModal('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง')
        }).finally(() => {
          eventBus.$emit('changeLoadingState', false)
        })
    },
    onClickRequestSendEmail() {
      if (!isValid(this.$route.query.userId)) this.toggleWarningModal('userID not found')
      else if (!isValid(this.$route.query.callbackUrl)) this.toggleWarningModal('callbackUrl not found')
      else if (!isValid(this.$route.query.aud)) this.toggleWarningModal('audienceId not found')
      else {
        eventBus.$emit('changeLoadingState', true)
        const params = new URLSearchParams()
        params.append('apikey', process.env.VUE_APP_BASE_TWO_FACTOR_KEY)
        params.append('callbackUrl', btoa(this.$route.fullPath))
        axios({
          method: 'POST',
          baseURL: process.env.VUE_APP_BASE_TWO_FACTOR_API,
          headers: {
            'Content-Type': 'application/json'
          },
          url: `users/${this.userId}/secrets`,
          params: params
        }).then(() => {
          this.toggleWarningModal('ระบบได้ทำการส่ง link สำหรับแสกน QR Code ไปยังอีเมลของคุณ กรุณาตรวจสอบอีเมลของคุณ')
        }).catch(error => {
          console.log(error.response)
          this.toggleWarningModal('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง')
        }).finally(() => {
          eventBus.$emit('changeLoadingState', false)
        })
      }
    },
    toggleWarningModal(msg) {
      this.warningMessages = []
      this.warningMessages.push(msg)
      this.modalWarning.display = true
    }
  }
}
</script>
<style>
a.text_blue_link {
  color: #007bff !important;
  text-decoration: none !important;
  background-color: transparent !important;
}
a.text_blue_link:hover {
  color: #4458b8!important;
  text-decoration: underline!important;
  cursor: pointer;
}

.card {
  border: 5px solid rgba(0, 0, 0, 0.125);
  border-radius: 1.25rem;
}

.blank-page {
  margin-top: 74px;
  /* margin-bottom: 30px; */
  /* height: 720px; */
  height: calc(100vh - 190px);
  min-height: 300px;
  display: flex;
}
.blank-page > div {
  justify-content: center;
  align-items: center;
  display: flex;
}
@media screen and (max-width: 1024px) {
    .nav-blank {
    padding: 20px 1rem
    }
    .blank-page {
        max-height: calc(100vh - 90px);
        height: calc(100vh - 190px);
    }
}

/* responsive */
@media screen and (max-width: 600px) {
  .blank-page > .container {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .blank-page {
    height: calc(100vh - 175px)!important;
  }
}

@media screen and (max-width: 600px) {
  body {
  min-height: 100%!important;
}
  .logo-shield {
    max-width: 160px;
  }
  .align-input {
    margin-left: 22px;
  }
}
</style>
